export default function detectMinFontSizeOverride(targetPx = 8) {
  // Create a hidden test element
  const el = document.createElement('span')
  el.textContent = 'Aa'
  Object.assign(el.style, {
    position: 'absolute',
    visibility: 'hidden',
    fontSize: `${targetPx}px`,
    lineHeight: 'normal',
    padding: '0',
    margin: '0',
    border: '0'
  })

  document.body.appendChild(el)

  const computed = window.getComputedStyle(el)
  const actualPx = parseFloat(computed.fontSize) || targetPx

  document.body.removeChild(el)

  // If the browser/user is enforcing a minimum font size,
  // actualPx will be > targetPx by a non-trivial amount.
  const ratio = actualPx / targetPx

  return {
    overridden: ratio > 1.05,   // 5% slack for rounding
    targetPx,
    actualPx
  }
}